












import { Component } from 'vue-property-decorator'
// @ts-ignore
import RouterHelper from '@/mixins/RouterHelper.vue'

// @ts-ignore
@Component
export default class Breadcrumb extends RouterHelper {
  get items () {
    // @ts-ignore
    const pathItems = this.$route.fullPath.split('/').slice(2) // 去掉语言参数
    return pathItems.map((item: string) => ({
      name: item,
      // @ts-ignore
      route: this.getCompleteRouteByPathObject({ name: item })
    }))
  }
}
